import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import type UploadFile from '../../../interfaces/UploadFile';

interface Props {
  uploadFiles?: UploadFile[];
  onCancel?: () => void;
}

export const FilesUploadErrorForm = ({ uploadFiles, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="pt-6">
      <div className="divide-gray-medium border-gray-medium mt-4 flex max-h-80 flex-col gap-2 divide-y overflow-auto border-y">
        {uploadFiles?.map((uploadFile) => (
          <div key={uploadFile.id} className="flex flex-col gap-1 px-1 py-1.5">
            <span className="text-blue-dark">{uploadFile.fileName}</span>
            {uploadFile.relativePath && uploadFile.relativePath !== uploadFile.fileName && (
              <span className="text-gray-dark truncate text-xs" title={uploadFile.relativePath}>
                {uploadFile.relativePath}
              </span>
            )}
            <span className="text-red-dark text-xs">{uploadFile.error}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-row items-center justify-end gap-2">
        <Button size="middle" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default FilesUploadErrorForm;
